<template>
  <div class="container">
    <div class="banner banner-events block block-shadow">
      <div class="row">
        <div class="col-lg-6 banner__content">
          <h5>{{ subtitle }}</h5>
          <h2>{{ title }}</h2>
          <p v-if="excerpt">{{ excerpt | decode | limit }}</p>
          <router-link tag="a" :style="{ color: primary }" :to="linkTextUrl">{{
            linkText
          }}</router-link>
        </div>
        <div class="col-lg-6 p-0">
          <img :src="featImg" :alt="featAlt" class="banner__feat" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  nane: "EventsBanner",
  props: {
    subtitle: {
      type: String,
      default: ""
    },
    featImg: {
      type: String,
      default: require("@/assets/media/backgrounds/default.jpg")
    },
    featAlt: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    excerpt: {
      type: String,
      default: ""
    },
    linkText: {
      type: String,
      default: ""
    },
    linkTextUrl: {
      type: String,
      default: "/"
    }
  },
  computed: {
    primary() {
      return this.$store.state.app.scheme.primary;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "node_modules/bootstrap/scss/mixins/_breakpoints.scss";

.banner {
  margin-bottom: 40px;
  .banner__content {
    font-family: "Gotham";
    padding: 50px 60px;
    h5 {
      color: $gray-500;
      font-family: "Gotham";
      font-size: $font-size-lg;
      font-weight: 500;
      margin-bottom: 15px;
    }
    h2 {
      color: $gray-900;
      font-size: $pbf-height-sm;
      font-weight: 500;
      margin-bottom: 10px;
    }
    p {
      color: $gray-700;
      font-size: $font-size-sm;
      margin: 0 0 65px;
    }
    a {
    }
  }
  .banner__feat {
    object-fit: cover;
    max-height: 300px;
    height: 100%;
    width: 100%;
  }
}
</style>
